import { Component, Input } from '@angular/core';

@Component({
  selector: 'section-anchor',
  templateUrl: './section-anchor.component.html',
  styleUrls: ['./section-anchor.component.scss'],
  standalone: false,
})
export class SectionAnchorComponent {
  @Input() valid = false;
  @Input() touched = false;
}
